AOW.SocialApp = function() {

};

AOW.SocialApp.init = function() {
	this.curstep = 0;
	this.designid = null;
	this.productid = null;
	this.isSelling = 0;
	this.img_filename = null;
	this.img_url = null;
	this.creation_id = null;
	this.lastpos = new Array(0,0);

	var me = this;


	$('#textSkip').on('click', function(){
		$('#theText').hide();
		$('#theText').attr('src','');
		$('#textarea').val('');
	});

	$('#logoSkip').on('click', function(){
		$('#theLogo').hide();
		$('#theLogo').attr('src','');
	});
	
	//Event listener to nextStep btn
	$('.btn-flat.next').on('click', function(e){
		me.showStep(me.curstep+1);

		e.preventDefault();
		e.stopPropagation();
	});

	//Event listener to prevStep btn
	$('.btn-flat.prev').on('click', function(e){
		//Skip the generating step when coming back
		if(me.curstep == 5)
			me.curstep--;

		me.showStep(me.curstep-1, true);

		e.preventDefault();
		e.stopPropagation();
	});

	//Event listener to scroller
	$("#social-app").find('.scroller').on('click', 'li img, li p', function(e){
		var liElem = $(this).parent();

		if (!$(liElem).hasClass('upload')){
			$(liElem).parent().find('li.active').removeClass('active');
			$(liElem).addClass('active');
		}

		//Call function in parent this
		var ret = AOW.SocialApp[$(liElem).parent().attr('data-action')](liElem);

		if (!ret) {
			e.preventDefault();
			e.stopPropagation();
		}
	});

	$('#social-app').find('.scroller').on('click','.btn-delete',function(e) {
		e.preventDefault();
		var me = this;

		//Delete this image
		AOW.UI.dialog({
			url: 'account/social-app/confirm-delete-image',
			data: {
				id: $(me).attr('data-id'),
				type: $(me).attr('data-type')
			},
			success: function() {
				var dialog = this;

				//Catch Delete form submit
				$(dialog).find('form').on('submit', function(e) {
					e.preventDefault();

					//Send delete request
					AOW.request({
						method: 'POST',
						url: 'account/social-app/delete-image',
						data: {
							id: $(me).attr('data-id')
						},
						success: function() {
							//Default back to another image
							$(me).closest('.scroller').find('li:first img').trigger('click');

							//Show upload box
							$('#'+$(me).attr('data-type')+'UploadLi').show();

							//Remove this image
							$(me).closest('li').remove();

							$(dialog).closeDialog();
						}
					});

					return false;
				});
			}
		});
	});

	//Event listener to dropdown
	$('div.dropdown').on('click', function(){
		if ($(this).hasClass('active')){
			$('div.dropdown.active').removeClass('active');
		}else{
			//Close previous one
			$('div.dropdown.active').removeClass('active');

			$(this).addClass('active');

			$(document).one('mouseup',function(){
				$('div.dropdown.active').removeClass('active');
			});
		}
	});

	$('.dropdown > li').on('click', function(e){
		$(this).parent().find('li.active').removeClass('active');
		$(this).addClass('active');

		//Call function in parent this
		$(this).parent().parent().children('span').html($(this).html());
		$(this).parent().parent().children('span').find('div').remove();

		var ret = AOW.SocialApp[$(this).parent().attr('data-action')](this);
		$(document).off('click');

		$('div.dropdown.active').removeClass('active');

		if (!ret){
			e.preventDefault();
			e.stopPropagation();
		}
	});

	//Event listener on font
	$('#textarea').on('change keyup',function(){
		me.changeFont();
	});

	$('#opacity').change(function(){
		me.changeLogo();
	});

	$('#downloadImage').click(function(){
		if (me.creation_id) {
			window.open(SITE_URL+'api/user/photoLabCreations/'+encodeURIComponent(me.creation_id)+'/download');
		}
	});

	me.designid = $('#theProduct').attr('data-designid');
	me.productid = $('#theProduct').attr('data-product');
	me.isSelling = $('#theProduct').attr('data-sell') == 1;
	me.designUrl = SITE_URL+$('#theProduct').attr('data-url');

	//Init preview selector
	$('#listPreviews').find('.card').on('click',function(e) {
		me.preview_id = $(this).attr('data-id');
		me.filename = $(this).attr('data-filename');
		me.id_product_preview = $(this).attr('data-id-product-preview');

		$('#step0').fadeIn();
		
		$('#listPreviews').fadeOut(400, function() {
			me.loadDesign();
		});
	});

	me.initUploader();
};


AOW.SocialApp.loadDesign = function() {
	var me = this;

	$('#theDesign').off('load');
	$('#theDesign').off('error');
	$('#theDesign').on('load',function(e){
		$('#theProduct').show();

		var newWidth, newHeight,
			w = $(this).width(),
			h = $(this).height();

		//Limit width to 540 and height to 480
		if(w > 540 && h/w * 540 <= 480) {
			newWidth = 540;
			newHeight = h/w * newWidth;

			$(this).width(newWidth);
			$(this).height(newHeight);

			w = newWidth;
			h = newHeight;
		} else if(h > 480 && w/h * 480 <= 540) {
			newHeight = 480;
			newWidth = w/h * newHeight;

			$(this).width(newWidth);
			$(this).height(newHeight);

			w = newWidth;
			h = newHeight;
		}

		$(this).attr('data-w',w).attr('data-h',h);

		$(this).css({'top':((500-h)/2)+'px','left':((560-w)/2)+'px'});

		me.showStep(1);

		$(this).off('load');
		$(this).off('error');
	});

	$('#theDesign').on('error',function(){
		$('#theProduct').hide();
		$('#step0').hide();
		$('#listPreviews').fadeIn();

		$(this).off('load');
		$(this).off('error');
		$(this).attr('src','');

		alert(__('account_ns_messages.imageCreatingError')+'\n\r'+__('account_ns_messages.errorPersist'));
	});

	$('#theDesign').attr('src', SITE_URL+'account/social-app/generate-image?designid='+me.designid+'&productid='+me.productid+ '&preview_id='+me.preview_id+'&filename='+me.filename+'&id_product_preview='+me.id_product_preview);
};

AOW.SocialApp.changeBackground = function(elem){
	var me = this;
	var name = $(elem).attr('data-name');

	if (name == "upload"){
		//Start upload process
//		$('#backgroundUploader').click();
		return true;
	}else if (name == "none"){
		//Nothing...
		$('#theBackground').hide();
	}else if (name == "custom"){
		var img = $(elem).attr('data-image');

		$('#theBackground').css({'width':'auto','height':'auto'});
		$('#theBackground').on('load',function(e){
			var w = $(this).width();
			var h = $(this).height();

			$(this).attr('data-w',w).attr('data-h',h);

			var nw = 560;
			var nh = nw*h/w;

			if (nh < 500){
				nh = 500;
				nw = nh*w/h;
			}

			$(this).css({'width':nw+'px','height':nh+'px','top':((500-nh)/2)+'px','left':((560-nw)/2)+'px'});

			$(this).off('load');
		});

		$('#theBackground').show();
		$('#theBackground').attr('src', img);
	}else{
		$('#theBackground').css({'width':'auto','height':'auto','top':'0','left':'0'});
		$('#theBackground').show();
		$('#theBackground').attr('src', IMG_URL+'social-app/background/final/'+name+'.png');
	}
};

AOW.SocialApp.changeFont = function(elem) {
	var me = this;

	var font = $("#fontContainer li.active").attr('data-name');
	var color = $("#colorContainer li.active").attr('data-name');
	var color2 = $("#color2Container li.active").attr('data-name');
	var size = $("#sizeContainer li.active").attr('data-name');
	var size2 = $("#size2Container li.active").attr('data-name');
	var align = $('#alignmentContainer li.active').attr('data-name');

	var text = $('#textarea').val();

	if (text === ""){
		$('#theText').hide();
	}else{
		var data = {'text':text, 'font':font, 'color':color, 'color2':color2, 'size':size, 'size2':size2, 'align':align};

		$('#theText').css({'width':'auto','height':'auto'});

		$('#theText').off('load');
		$('#theText').on('load',function(e){
			var w = $(this).width();
			var h = $(this).height();

			$(this).attr('data-w',w).attr('data-h',h);

			if ($(this).attr('data-ratio')){
				var ratio = $(this).attr('data-ratio');
				w = w*ratio;
				h = h*ratio;
				$(this).width(w).height(h);
			}

			if (!$(this).hasClass('moved')){
				$(this).css({'top':((500-h)/2)+'px','left':((560-w)/2)+'px'});
			}

			me.placeResizer();

			$(this).off('load');
		});

		$('#theText').attr('src', SITE_URL+'account/social-app/generate-text?'+jQuery.param(data));
		$('#theText').show();
		me.placeResizer();
	}
};

AOW.SocialApp.changeLogo = function(elem) {
	var me = this;

//	var name = $(elem).attr('data-name');
	var name = $('#step3 ul.scroller li.active').attr('data-name');
	var opacity = $('#opacity').val();

	var thename = $(elem).attr('data-name');

	if (thename == "upload"){
		//Start upload process
//		$('#backgroundUploader').click();
		return true;
//		alert('SOON');
	}else if (name == "none"){
		//Nothing...
		$('#theLogo').hide();
	}else {
		var img = $('#step3 ul.scroller li.active').attr('data-image');

		$('#theLogo').show();

		$('#theLogo').off('load');
		$('#theLogo').on('load',function(e){
			var w = $(this).width();
			var h = $(this).height();

			$(this).attr('data-w',w).attr('data-h',h);

			var ow = w;
			var oh = h;

			if (w > 280){
				w = 280;
				h = w*oh/ow;
			}

			if (h > 250){
				h = 250;
				w = h*ow/oh;
			}

			$(this).width(w).height(h);

			me.placeResizer();

			$(this).off('load');
		});

	
		//Change Img if it's not the same url
		var logo_imgurl;
		if (name == "custom"){
			logo_imgurl = img;
		} else {
			logo_imgurl = IMG_URL+'social-app/logo/final/'+name+ '.png';
		}

		if($('#theLogo').attr('src') != logo_imgurl) {
			$('#theLogo').css({'width':'auto','height':'auto'});
			$('#theLogo').attr('src', logo_imgurl);
		}

		$('#theLogo').css({'opacity':(opacity/100)});
	} 
};

AOW.SocialApp.canGenerateImage = function() {
	var ready = true;
	$('#theBackground, #theDesign').add($('#theText, #theLogo').filter(':visible')).each(function() {
		if (!this.complete || !this.naturalWidth || !this.naturalHeight ||
			(this.id !== 'theBackground' && ($(this).width() < 1 || $(this).height() < 1))) {
			ready = false;
		}
	});
	return ready;
};

AOW.SocialApp.showStep = function(nb, reverse) {
	var me = this;

	if (nb === 4 && !me.canGenerateImage()) {
		alert(__('account_ns_messages.imageCreatingError')+'\n\r'+__('account_ns_messages.errorPersist'));
		return;
	}

	switch(nb){
		case 1:
			me.startMovingDesign();
		break;
		case 2:
			me.startMovingText();
			me.changeFont();
		break;
		case 3:
			me.startMovingLogo();
			me.changeLogo();
		break;
		case 4:
			me.startGenerateImage();
		break;
		default:
			me.disableMoving();
		break;
	}

	me.curstep = nb;

	var startx = 200;
	if (reverse){
		startx = -200;
	}

	$('section>aside>div').css({'z-index':'1'});
	$('aside div').stop(true,true);
	$('#step'+nb).css({'left':startx+'px','z-index':'999','display':'block'}).animate({'left':'0'},function(){
		$('section>aside>div').not('#step'+nb).hide();

		//Special action
		if (me.curstep == 2){
			//Select random style

			//Select text
			$('#textarea').focus();
			$('#textarea').select();
		}
	});
};

AOW.SocialApp.startGenerateImage = function() {
	var me = this, data = {};

	me.disableMoving();

	data.background = $('#theBackground').attr('src');

	data.design = $('#theDesign').attr('src');
	data.designPosition = $('#theDesign').position();
	data.designPosition.width = $('#theDesign').width();
	data.designPosition.height = $('#theDesign').height();

	if($('#theText').is(':visible')) {
		data.text = $('#theText').attr('src');
		data.textPosition = $('#theText').position();
		data.textPosition.width = $('#theText').width();
		data.textPosition.height = $('#theText').height();
	}

	if($('#theLogo').is(':visible')) {
		data.logo = $('#theLogo').attr('src');
		data.logoPosition = $('#theLogo').position();
		data.logoPosition.width = $('#theLogo').width();
		data.logoPosition.height = $('#theLogo').height();
		data.logoPct = $('#opacity').val();
	}

	$.get(SITE_URL+'ajax/account/social-app/generate-final-image',data,function(response){
		try {
			if (typeof response === 'string') {
				response = $.parseJSON(response);
			}
		} catch (e) {
			alert(__('account_ns_messages.dataProcessingError')+'\n\r'+__('account_ns_messages.errorPersist'));
			return;
		}

		response = response.data || response;

		if (response.filename && response.id){
			me.creation_id = response.id;
			me.img_filename = response.filename;
			me.img_url = response.url;
			me.imgid = me.img_filename.substr(0, me.img_filename.lastIndexOf('.'));
			me.showStep(5);
		}else{
			alert(__('account_ns_messages.dataAnalyzingingError')+'\n\r'+__('account_ns_messages.errorPersist'));
		}
	}).fail(function(xhr){
		if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.error === 'imageDimensionsExceeded') {
			alert(__('account_ns_messages.imageDimensionsExceeded', xhr.responseJSON.data));
			me.showStep(3, true);
			return;
		}
		alert(__('account_ns_messages.imageCreatingError')+'\n\r'+__('account_ns_messages.errorPersist'));
	});
};

AOW.SocialApp.startMovingDesign = function(){
	this.disableMoving();
	$('#theDesign').addClass('moving');
	this.startMoving();
};

AOW.SocialApp.startMovingText = function() {
	this.disableMoving();
	$('#theText').addClass('moving');
	this.startMoving();
};

AOW.SocialApp.startMovingLogo = function() {
	this.disableMoving();
	$('#theLogo').addClass('moving');
	this.startMoving();
};

AOW.SocialApp.startMoving = function() {
	var me = this;

	$('.moving').off('mousedown.socialAppMove').on('mousedown.socialAppMove', function(e){

		me.lastpos = new Array(e.pageX, e.pageY);

		$('#theProduct').off('.socialAppMove').on('mousemove.socialAppMove', function(e){
			$('.moving').addClass('moved');

			var thispos = new Array(e.pageX, e.pageY);
			var dx = thispos[0]-me.lastpos[0];
			var dy = thispos[1]-me.lastpos[1];

			me.lastpos = thispos;

			var pos = $('.moving').position();
			if (!pos) {
				return;
			}

			$('.moving').css({'top':(pos.top+dy)+'px','left':(pos.left+dx)+'px'});

			me.placeResizer();

			e.stopPropagation();
			e.preventDefault();
		});

		$('#theProduct').on('mouseup.socialAppMove', function(e){

			$('#theProduct').off('.socialAppMove');

			me.placeResizer();

			e.stopPropagation();
			e.preventDefault();
		});
		
		e.stopPropagation();
		e.preventDefault();
	});

	//Add resizer
	$('<div id="resizer"></div>').appendTo('#theProduct');
	me.placeResizer();

	$('#resizer').off('mousedown.socialAppMove').on('mousedown.socialAppMove', function(e){
		$('#theProduct').off('.socialAppMove').on('mousemove.socialAppMove', function(e){
			var elem = $($('.moving').get(0));
			if (!elem.length) {
				return;
			}

			var pos = $(elem).offset();
			if (!pos) {
				return;
			}

			//Base width/height
			var mw = parseFloat(elem.attr('data-w'),10);
			var mh = parseFloat(elem.attr('data-h'),10);

			//New size based on horizontal displacement
			var nw = e.pageX-pos.left;
			var nh = nw*mh/mw;

			//New size based on vertical displacement
			var nh2 = e.pageY-pos.top;
			var nw2 = nh2*mw/mh;

			//Set new size based on vertical displacement if it's smaller
			if (nw2 < nw){
				nw = nw2;
				nh = nh2;
			}

			//Limit width/height to the base ones
			if (nw > mw || nh > mh){
				nw = mw;
				nh = mh;
			}

			//Minimum width of 60
			if(nw < nh && nw < 100) {
				nw = 100;
				nh = nw*mh/mw;
			}
			//Minimum height of 100
			else if(nh < 100) {
				nh = 100;
				nw = nh*mw/mh;
			}

			//Size on element
			elem.width(nw).height(nh);

			//Reposition resizer
			me.placeResizer();

			e.preventDefault();
			e.stopPropagation();
		});

		$(document).off('mouseup.socialAppMove').one('mouseup.socialAppMove', function(e){
			me.placeResizer();

			//Save ratio
			var elem = $($('.moving').get(0));
			if (elem.length) {
				elem.attr('data-ratio',(elem.width()/elem.attr('data-w')));
			}

			$('#theProduct').off('.socialAppMove');
		});

		e.preventDefault();
		e.stopPropagation();
	});
};

AOW.SocialApp.placeResizer = function() {
	var elem = $($('.moving:visible').get(0));
	if (!elem.length || !$('#resizer').length) {
		$('#resizer').hide();
		return;
	}

	var pos = elem.position();
	if (!pos) {
		$('#resizer').hide();
		return;
	}

	var left = pos.left+elem.width();
	var top = pos.top+elem.height();

	$('#resizer').css({'left':left+'px','top':top+'px'}).show();
};

AOW.SocialApp.disableMoving = function() {
	$('.moving').off('.socialAppMove').removeClass('moving');
	$('#theProduct').off('.socialAppMove');
	$(document).off('.socialAppMove');

	//Remove resizer...
	$('#resizer').remove();
};

AOW.SocialApp.file_id = 0;
AOW.SocialApp.MAX_FILE_SIZE = 10;

AOW.SocialApp.upLoadStart = function(e, file, fileReader, type) {
	var me = this, 
		extension = file.name.substr(file.name.lastIndexOf('.')+1).toLowerCase();
	
	//Check if valid extension
	if(	extension !== 'jpg' &&
		extension !== 'jpeg' &&
		extension !== 'png' &&
		extension !== 'gif') {

		fileReader.abort();

		alert(__('account_ns_messages.invalidFile')+"\n\r"+__('account_ns_messages.uploadValidImage'));
		return false;
	}

	//Check if file size is too big
	if(file.size > me.MAX_FILE_SIZE*1000000) {
		fileReader.abort();

		alert(__('account_ns_messages.fileTooBig')+"\n\r"+__('account_ns_messages.uploadSmallerImage')+me.MAX_FILE_SIZE+ 'mb');
		return false;
	}

	//Define ID of file for HTML5 upload
	file.id = me.file_id;
	me.file_id++;

	return true;
};

AOW.SocialApp.upClientLoad = function(e, file, fileReader, type) {
	//Add to list of files
	var shortName = file.name.substr(0, 13);
	if (file.name.length > 13)
		shortName = shortName+"...";
	
	file.iw = 2;
	file.ih = 2;
	file.typeUpload = type;

	$('#'+file.typeUpload+'Uploader').hide();
	$('#'+file.typeUpload+'Progress>div').css({'width':'0'});
	$('#'+file.typeUpload+'Progress').show();
};

AOW.SocialApp.upServerProgress = function(e, file, force, type) {
	var percentLoaded = Math.round((e.loaded / e.total) * 100);

	//Stuck at 98% until done
	if(percentLoaded > 98 && force !== true) {
		percentLoaded = 98;
	}

	if (typeof e.loaded !== 'undefined'){
		$('#'+file.typeUpload+'Progress>div').css({'width':percentLoaded+'%'});
	}else{
		$('#'+file.typeUpload+'Progress>div').css({'width':'99%'});
	}
};

AOW.SocialApp.upSuccess = function(e, file, type) {
	var me = this,result;

    var errcode = "01";
    try{
   		errcode = file.type+"("+file.iw+"x"+file.ih+"x"+file.size+')';
   	} catch(exception) {
   		errcode = "02";
   	}

	try {
		result = $.parseJSON(e.target.response);
	} catch (exception) {
	    // invalid json input, set to null
	    result = null;
	    alert(__('account_ns_messages.uploadErrorS')+errcode);

	    return;
	}

	errcode = errcode+"["+result.data.width+'.'+result.data.height+"]";

	if (result.error == "toomany"){
		alert(__('account_ns_messages.fiveOnly')+type+__('account_ns_messages.manageAccount')+type+__('account_ns_messages.yourAccount'));

		return;
	}

	if (result.code != 200){
	    alert(__('account_ns_messages.uploadErrorT')+errcode);

	    return;
	}

	me.upServerProgress({ loaded: 1, total: 1}, file, true);

	switch(result.code){
		case 200://OK
			$('#'+file.typeUpload+'Progress').hide();
			$('#'+file.typeUpload+'Uploader').val('').show();

			var li = $('<li data-name="custom" data-image="'+result.data.url+'">'+
							'<img class="custom" src="'+result.data.url+'" alt="'+__('account_ns_messages.uploadImageAlt')+'"/>'+
							'<button type="button" class="btn-flat waves-effect waves-circle btn-delete" data-id="'+result.data.id+'" data-type="'+type+'"><i class="material-icons">'+__('account_ns_messages.delete')+'</i></button>'+
							'<p>'+__('account_ns_messages.uploaded')+'</p>'+
						'</li>');

			li.insertBefore('#'+file.typeUpload+'UploadLi');

			if (result.data.stillAvailable == 'false'){
				$('#'+type+'UploadLi').hide();
			}
		break;
	}
};

AOW.SocialApp.initUploader = function() {
	var me = this, data;

	//Upload background
	if ("FileReader" in window && "FormData" in window){
		$('#backgroundUploader').html5Uploader({
			name: 'fileUpload',
			postUrl: 'ajax/account/social-app/upload',
			data: {
				type: 'background'
			},
			onClientLoadStart: function(e, file, fileReader) {
				me.upLoadStart(e, file, fileReader, 'background');
			},
			onClientLoad: function(e, file, fileReader) {
				me.upClientLoad(e, file, fileReader, 'background');
			},
			onServerLoadStart: function() {
			},
			onServerLoad: function(e, file) {
			},
			onServerProgress: function(e, file, fileReader) {
				me.upServerProgress(e, file, fileReader, 'background');
			},
			onSuccess: function(e, file) {
				me.upSuccess(e, file, 'background');
			}
		});
	}

	//Upload background
	if ("FileReader" in window && "FormData" in window){
		$('#logoUploader').html5Uploader({
			name: 'fileUpload',
			postUrl: 'ajax/account/social-app/upload',
			data: {
				type: 'logo'
			},
			onClientLoadStart: function(e, file, fileReader) {
				me.upLoadStart(e, file, fileReader, 'logo');
			},
			onClientLoad: function(e, file, fileReader) {
				me.upClientLoad(e, file, fileReader,'logo');
			},
			onServerLoadStart: function() {
			},
			onServerLoad: function(e, file) {
			},
			onServerProgress: function(e, file, fileReader) {
				me.upServerProgress(e, file, fileReader,'logo');
			},
			onSuccess: function(e, file) {
				me.upSuccess(e, file,'logo');
			}
		});
	}
};
